import React from 'react';

const  ConfirmationModal = ({toggleModal, rowData, onDelete, onDownload, action, page}) => {

    const handleDeleteClick = () => {
        onDelete(rowData, page);
        toggleModal();
    };

    const handleDownload = () => {
        onDownload(rowData);
        toggleModal();
    }
    return( 
        <div className='modal-overlay'>
            <div className='modal-container' style={{'width': 'min-content'}}>
                <div className='modal-header'>
                    <span>Confirmation</span>                   
                    <se-icon size='small' option='button' onClick={toggleModal}>
                        action_close
                    </se-icon>
                </div>
                <div className='modal-body'>
                  { action?.includes('delete') && <span>Are you sure you want to delete {page?page:''} {rowData.name?rowData.name:''} ? </span>}
                  { action?.includes('download') && <span>Are you sure you want to download the document {rowData.id} ? </span>}
                </div>
                <div className='modal-footer'>
                    <se-button option="outline" onClick={toggleModal}>Cancel</se-button>
                    <se-button option="flat" color="primary" onClick={action?.includes('delete') ? handleDeleteClick : handleDownload}>Yes</se-button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationModal;